import React, { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { get } from 'lodash';

export interface ScrollableProps {
  itemCount: number;
  children: React.ReactNode;
  elementRef?: HTMLDivElement | null;
}

interface WrapperProps {
  height: number;
  itemCount: number;
}

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  background: white;

  ${(props: WrapperProps) => {
    return props.itemCount > 1
      ? css`
          height: ${props.height}px;
        `
      : '';
  }}

  ${(props: WrapperProps) => {
    return props.height > 400
      ? css`
          overflow-y: auto;
        `
      : '';
  }}
  max-height: 400px;

  scrollbar-width: thin !important;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    width: 12px;
  }
  ::-webkit-scrollbar:horizontal {
    height: 30px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    border: 2px solid white;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: white;
  }

  @media (max-width: 768px) {
    max-height: 300px;
    overflow-y: auto;
  }
`;

const Scrollable = (props: ScrollableProps) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (props.elementRef) {
      const newHeight = get(props.elementRef, 'clientHeight') ?? 0;
      setHeight(newHeight);
    }
  }, [props.elementRef, props.itemCount]);

  return (
    <Wrapper itemCount={props.itemCount} height={height}>
      {props.children}
    </Wrapper>
  );
};

export default Scrollable;
